import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useNavigate } from "react-router";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Select from "react-select";
import { api_path } from "../../shared.js";
import swal from "sweetalert";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
export function ProfileForm() {
    const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
    const [getFirstName, setFirstName] = useState([]);
    const [getLastName, setLastName] = useState([])
    const [getNickName, setNickName] = useState([]);
    const [getEmail, setEmail] = useState([])
    const [getPhone, setPhone] = useState([])
    const [getRole, setRole] = useState([]);
    const [subjectName, setSubjectName] = useState("");
    
    const handleSubmit = (event) => {
    }
  return (
    <Container maxWidth="lg" className="content-wrap">
      <Grid container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
        </Grid>
        <Grid container spacing={2}>
            <label className="head">Your Profile</label>
          </Grid>
        <form  onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <label className="head">{subjectName}</label>
          </Grid>
          <Grid container className="Box" spacing={2}>
            <Grid item xs={12} sm={6}>
              <label>First Name</label>
              <span className="red">*</span>
              <TextField
                size="small"
                name="getFirstName"
                variant="outlined"
                required
                fullWidth
                id="getFirstName"
                value={getFirstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label>Last Name</label>
              <span className="red">*</span>
              <TextField
                size="small"
                name="getLastName"
                variant="outlined"
                required
                fullWidth
                id="getLastName"
                value={getLastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Grid>
               
            <Grid item xs={12} sm={6}>
              <label>Nick Name</label>
              <span className="red">*</span>
              <TextField
                size="small"
                name="getNickName"
                variant="outlined"
                required
                fullWidth
                id="getNickName"
                value={getNickName}
                onChange={(e) => setNickName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label>Email</label>
              <span className="red">*</span>
              <TextField
                size="small"
                name="getEmail"
                variant="outlined"
                required
                fullWidth
                id="getEmail"
                value={getEmail}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <label>Telephone</label>
              <span className="red">*</span>
              <TextField
                size="small"
                name="getPhone"
                variant="outlined"
                required
                fullWidth
                id="getPhone"
                value={getPhone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label>Role</label>
              <span className="red">*</span>
              <TextField
                size="small"
                name="getRole"
                variant="outlined"
                required
                fullWidth
                id="getRole"
                value={getRole}
                onChange={(e) => setRole(e.target.value)}
              />
            </Grid>
            <br />
          <Grid container spacing={2} className="break">
            <Grid item xs={12} sm={6}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={goBack}
              >
                &larr; Go Back
              </Button>
            </Grid>
          </Grid>
          </Grid>
        </form>
      
      </Grid>
    </Container>
  )
}

export default ProfileForm